import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { getLogo } from '../lib/api';

const LogoContext = createContext();

export const useLogo = () => {
  const context = useContext(LogoContext);
  if (!context) {
    throw new Error('useLogo must be used within a LogoProvider');
  }
  return context;
};

export const LogoProvider = ({ children }) => {
  const [logoUrl, setLogoUrl] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchLogo = useCallback(async () => {
    try {
      const response = await getLogo();
      if (response.data?.logo_url) {
        setLogoUrl(response.data.logo_url);
      }
    } catch (err) {
      // No logo set or error - use default
      console.log('Using default logo');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchLogo();
  }, [fetchLogo]);

  const updateLogo = useCallback((newLogoUrl) => {
    setLogoUrl(newLogoUrl);
  }, []);

  const value = {
    logoUrl,
    loading,
    updateLogo,
    refreshLogo: fetchLogo,
  };

  return (
    <LogoContext.Provider value={value}>
      {children}
    </LogoContext.Provider>
  );
};

export default LogoContext;
